export default {
  hero: {
    price: 'NeatDocs — $99/year',
    titleLines: ['Every document.', 'One place.', 'Always ready.'],
    subtitle: 'Stop relying on your inbox as a filing system. NeatDocs gives you a permanent, organized home for every receipt, bill, invoice, and contract — so nothing gets lost and tax season never catches you off guard.',
    ctaPrimary: 'Start Free Trial',
    ctaSecondary: 'Buy Now',
    checks: ['14-day free trial', '30-day money-back guarantee'],
    imageAlt: 'A view of all your files — NeatDocs file table showing receipts, bills, and invoices organized by folder, date, and description',
  },
  marquee: {
    title: 'Mentioned by',
  },
  howItWorks: {
    label: 'How NeatDocs works',
    title: 'One place for every document your business creates',
    subtitle: 'Capture receipts the moment they happen. Find any document in seconds. Always be ready for tax season — without the scramble.',
    slides: [
      {
        eyebrow: 'Capture',
        title: 'Snap, email, or upload — it\'s automatically organized',
        description: 'Every document your business produces can flow into NeatDocs the way that works for you. Snap a photo with the mobile app, forward an emailed receipt, or drag and drop from your desktop. NeatDocs automatically classifies it as a receipt, bill, invoice, or document — no manual sorting required.',
        bullets: [
          'Mobile app capture — snap receipts on the go',
          'Email-in capture — forward receipts directly into NeatDocs',
          'Web upload — drag and drop from any device',
          'Auto document classification on every file',
        ],
        image: '/neatdocs-capture.png',
        width: 1400,
        height: 688,
        alt: 'NeatDocs receipt capture — a receipt detail view showing vendor, date, amount, and classification fields next to the scanned invoice',
      },
      {
        eyebrow: 'Organize',
        title: 'A filing cabinet that works the way you think',
        description: 'Create folders and subfolders that match how your business runs. Organize by month, property, client, or project. Everything is keyword-searchable so you can find any document in seconds — even years later.',
        bullets: [
          'Fully customizable folder structure',
          'Keyword search across all documents',
          'Filter by date, type, vendor, or amount',
          'Bank-level encryption on every file',
        ],
        image: '/neatdocs-organize.webp',
        width: 1400,
        height: 700,
        alt: 'NeatDocs Organize view showing the Vendors folder inside My Cabinet, with a searchable file table of receipts and documents',
      },
      {
        eyebrow: 'Be Ready',
        title: 'Ready for whatever comes up. No scrambling required.',
        description: 'Tax season, an insurance claim, an audit, a question from your accountant — you never know exactly when you\'ll need a document, only that you will. With NeatDocs, everything is already organized and one search away, on your phone or your laptop, whenever the moment arrives. No digging through email. No wondering if you kept that one receipt. It\'s already there.',
        bullets: [
          'Find any document in seconds, right from your phone',
          'Ready to send to your accountant, bookkeeper, or anyone else',
          'Nothing needs an explanation — it\'s already labeled and dated',
          'Always available, on any device, whenever you need it',
        ],
        image: '/neatdocs-be-ready.png',
        width: 1400,
        height: 700,
        alt: 'NeatDocs quick search view showing the Tax Documents folder with instant search results for receipts, bills, and invoices',
      },
    ],
  },
  testimonials: {
    title: 'What our customers say',
    subtitle: 'Real stories from freelancers and small business owners using NeatDocs every day.',
    items: [
      {
        name: 'Steve B.',
        role: 'Independent Consultant',
        quote: 'I\'ve used Neat since 2008, initially for my independent consulting business, and now personally. It\'s a superb app for receipts, yes I could use Google or Microsoft apps and cloud drives, but it would take too much time. I love Neat and recommend it.',
        logo: '/testimonials/Steve_Bauer.webp',
      },
      {
        name: 'Deborah W.',
        role: 'Customer',
        quote: 'Been using Neat for over 15 years. So wonderful. I load and then send to me CPA. Easy!!',
        logo: '/testimonials/Deborah W.webp',
      },
      {
        name: 'Bud J.',
        role: 'Customer',
        quote: 'GREAT FOR TAXES!',
        logo: '/testimonials/Bud_Joyner.webp',
      },
    ],
  },
  bottomCta: {
    title: 'Get organized today.',
    subtitle: 'Start your free 14-day trial of NeatDocs. Every receipt, bill, and invoice in one place. Always ready when you need it.',
    cta: 'Start Free Trial',
    buyNow: 'Buy Now',
    price: '$99',
    per: 'per year · $8.25/month',
    cancelAnytime: 'Cancel anytime',
    moneyBack: '30-day money-back guarantee',
    taxReady: 'Ready for tax season immediately',
  },
}
